import * as signalR from "@aspnet/signalr";

class wSocket {
    constructor() {
        // const { PROD } = process.env;
        let loca = location.origin.match("223") ? "http://192.168.1.160" : location.origin;
        const SERVER_BASE_URL = `${loca}/`;
        this.ws_server_base_url = `${SERVER_BASE_URL}chat`;
        this.connection = null;
        this.UserRoom = ''//用户组
        this.UserType = ''//用户类型
        this.wsData = []
        this.wsSocketStatus = false;
    }

    /**
     * 创建链接
     */

    connectToHub(){
        let _this = this;
        let connection = new signalR.HubConnectionBuilder()
        .withUrl(this.ws_server_base_url, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Information)
        // .withAutomaticReconnect({ nextRetryDelayInMilliseconds: () => 60000 })
        .build();

        //连接失败重新连接
        connection.onclose(()=>{
            _this.timeoutReconnect()
        })
        
        this.connection = connection;
        
    }


    /**
     *  手动启动
     */
     timeoutReconnect() {
        setTimeout(() => {
            this.connectSatrt();
        }, 1000);
    }

    /**
     * 启动/重新连接
     */
    connectSatrt(){
        let _this = this;
        _this.connection.start().then(()=>{
            // console.log(_this.UserRoom)
            //请求订阅，设置用户组，请求
           _this.setWkInvoke()
        }).catch(()=>{
                _this.timeoutReconnect()
        })
    }
    /**
     * 订阅请求
     */
    setWkInvoke(){
        let _this = this;
        _this.connection.invoke(_this.UserRoom, this.UserType)
        .then(response => {
        //   console.log(response)
        }).catch((e) => {
            //订阅失败 重新订阅
            _this.setWkInvoke()
        });
    }

    /**
     * 
     * @param {*} userType 用户类型
     * @param {*} userRoom 用户组
     * @returns 
     */

    async register(userRoom, userType){
        let _this = this;
      
        this.UserType = userType
        this.UserRoom = userRoom
        

            await this.connectToHub();
            await this.connectSatrt();

        return  new Promise((resolve)=>{
            resolve(this.connection)
        })

    }
}

export default wSocket;


//////////////////
// WEBPACK FOOTER
// ./config/wSocket.js
// module id = +I0W
// module chunks = 18